import { render, staticRenderFns } from "./StudyCalendar.vue?vue&type=template&id=be923e2a&scoped=true"
import script from "./StudyCalendar.vue?vue&type=script&lang=js"
export * from "./StudyCalendar.vue?vue&type=script&lang=js"
import style0 from "./StudyCalendar.vue?vue&type=style&index=0&id=be923e2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be923e2a",
  null
  
)

export default component.exports